import { render } from "./index.vue?vue&type=template&id=ebabb02c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=ebabb02c&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=ebabb02c&lang=css"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebabb02c"]])

export default __exports__